export const newPassword = {
  password: {
    presence: true,
    length: {
      minimum: 7,
      message: "^Min 7 characters with at least 1 number and capital letter"
    },
    format: {
      pattern: /(.*\d.*[A-Z].*)|.*[A-Z].*\d.*/,
      message: "^Min 7 characters with at least 1 number and capital letter"
    }
  },
  password_confirmation: {
    presence: true,
    equality: {
      attribute: "password",
      message: '^Password confirmation is not the same as the password specified'
    }
  }
}



// WEBPACK FOOTER //
// ./src/validators/newPassword.js